// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6Pk2a","type":"styles_type__3hotT","choices":"styles_choices__3JUIf"};